import { EnvironmentProviders, inject, Provider, provideAppInitializer } from "@angular/core";
import { provideTransloco, TranslocoService } from "@jsverse/transloco";
import { TranslocoHttpLoader } from "./transloco.http-loader";
import { firstValueFrom } from "rxjs";

export const provideTranslation = (): Array<
  Provider | EnvironmentProviders
> => {
  return [
    provideTransloco({
      config: {
        availableLangs: [
          {
            id: "fr",
            label: "french",
          },
          {
            id: "dz",
            label: "arabic",
          },
        ],
        defaultLang: "fr",
        fallbackLang: "fr",
        reRenderOnLangChange: true,
        prodMode: true,
      },
      loader: TranslocoHttpLoader,
    }),
    provideAppInitializer(() => {
        const initializerFn = (() => {
        const translocoService = inject(TranslocoService);
        const defaultLang = translocoService.getDefaultLang();
        translocoService.setActiveLang(defaultLang);

        return () => firstValueFrom(translocoService.load(defaultLang));
      })();
        return initializerFn();
      }),
  ];
};
